import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../Auth/_redux/authRedux";
import SVG from "react-inlinesvg";
import { isUnauthorized } from "../../utils/utils";
import {
  commissionListApi,
  editCommissionApi,
} from "../../../axios/services/services";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import ErrorModal from "../Modal/ErrorModal";
import { Button, Card } from "react-bootstrap";
import { CommissionSchema } from "../../FormikSchema/FormikSchema";
import SuccessModal from "../Modal/SuccessModal";

const initialValues = {
  // General Payment
  achpercentageUserGeneral: 0,
  achfixedrateUserGeneral: 0,
  echeckpercentageUserGeneral: 0,
  echeckfixedrateUserGeneral: 0,
  creditcardpercentageUserGeneral: 0,
  creditcardfixedrateUserGeneral: 0,
  debitcardpercentageUserGeneral: 0,
  debitcardfixedrateUserGeneral: 0,
  echeckpercentageBusinessGeneral: 0,
  echeckfixedrateBusinessGeneral: 0,
  achpercentageBusinessGeneral: 0,
  achfixedrateBusinessGeneral: 0,
  creditcardpercentageBusinessGeneral: 0,
  creditcardfixedrateBusinessGeneral: 0,
  debitcardpercentageBusinessGeneral: 0,
  debitcardfixedrateBusinessGeneral: 0,

  // SC Payment
  echeckfixedUserSC: 0,
  echeckpercentageUserSC: 0,
  achpercentageUserSC: 0,
  achfixedrateUserSC: 0,
  echeckfixedBusinessSC: 0,
  echeckpercentageBusinessSC: 0,
  achpercentageBusinessSC: 0,
  achfixedrateBusinessSC: 0,
};

function Commission(props) {
  const [commissionList, setCommissionList] = useState([]);
  // General Payment
  const [ACHTypeUserGeneral, setACHTypeUserGeneral] = useState(
    "percentageUserGeneral"
  );
  const [ACHTypeBusinessGeneral, setACHTypeBusinessGeneral] = useState(
    "percentageBusinessGeneral"
  );
  const [creditCardTypeUserGeneral, setCreditCardTypeUserGeneral] = useState(
    "percentageUserGeneral"
  );
  const [debitCardTypeUserGeneral, setDebitCardTypeUserGeneral] = useState(
    "percentageUserGeneral"
  );
  const [echeckTypeUserGeneral, setEcheckTypeUserGeneral] = useState(
    "percentageUserGeneral"
  );
  const [
    creditCardTypeBusinessGeneral,
    setCreditCardTypeBusinessGeneral,
  ] = useState("percentageBusinessGeneral");

  const [echeckTypeBusinessGeneral, setEcheckTypeBusinessGeneral] = useState(
    "percentageBusinessGeneral"
  );
  const [
    debitCardTypeBusinessGeneral,
    setDebitCardTypeBusinessGeneral,
  ] = useState("percentageBusinessGeneral");

  // SC Payment

  const [EcheckTypeUserSC, setEcheckTypeUserSC] = useState("percentageUserSC");
  const [EcheckTypeBusinessSC, setEcheckTypeBusinessSC] = useState(
    "percentageBusinessSC"
  );
  const [ACHTypeUserSC, setACHTypeUserSC] = useState("percentageUserSC");
  const [ACHTypeBusinessSC, setACHTypeBusinessSC] = useState(
    "percentageBusinessSC"
  );

  const [loading, setLoading] = useState(false);
  const [isSuccessModalShow, setSuccessModalShow] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [updateCommissionList, setUpdateCommissionList] = useState(0);

  useEffect(() => {
    async function getCommissionList() {
      // enableLoading();
      const commissionListResponse = await commissionListApi({});
      const { Error, data } = commissionListResponse || {};
      // disableLoading();
      if (Error) {
        const { message } = Error || {};
        isUnauthorized({ response: commissionListResponse });
        setErrorMessage(message);
        handleErrorModalShow();
        return;
      }
      setCommissionList(data ? data : []);
      if (data && data.length > 0) {
        data.map((commissionData) => {
          const {
            transactionModeId,
            commission_percentage,
            commission_rate,
            userType,
            is_sc,
            is_percentage,
          } = commissionData || {};
          // userType = 2 ( Individual User)
          // userType = 3 (Bussiness User)

          // E-Check User - General
          // Individual - General - Echeck ===> is_sc = false, transactionmode = 1, usertype = 2
          if (transactionModeId === 1 && userType === "2" && !is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "echeckpercentageUserGeneral",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "echeckfixedrateUserGeneral",
                commission_rate ? commission_rate : 0
              );
            }
            setEcheckTypeUserGeneral(
              is_percentage ? "percentageUserGeneral" : "rateUserGeneral"
            );
          }

          // E-check User - SC
          // Individual - SC - Echeck ==> is_sc = true, transactionmode = 1, usertype = 2
          if (transactionModeId === 1 && userType === "2" && is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "echeckpercentageUserSC",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "echeckfixedUserSC",
                commission_rate ? commission_rate : 0
              );
            }
            setEcheckTypeUserSC(
              is_percentage ? "percentageUserSC" : "rateUserSC"
            );
          }

          // E-check Business - General
          // Business - General - Echeck ===> is_sc = false, transactionmode = 1, usertype = 3
          if (transactionModeId === 1 && userType === "3" && !is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "echeckpercentageBusinessGeneral",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "echeckfixedrateBusinessGeneral",
                commission_rate ? commission_rate : 0
              );
            }
            setEcheckTypeBusinessGeneral(
              is_percentage
                ? "percentageBusinessGeneral"
                : "rateBusinessGeneral"
            );
          }

          // E-check Business - SC
          // Business - SC - Echeck ==> is_sc = true, transactionmode = 1, usertype = 3
          if (transactionModeId === 1 && userType === "3" && is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "echeckpercentageBusinessSC",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "echeckfixedBusinessSC",
                commission_rate ? commission_rate : 0
              );
            }
            setEcheckTypeBusinessSC(
              is_percentage ? "percentageBusinessSC" : "rateBusinessSC"
            );
          }

          // ACH User - General
          if (transactionModeId === 2 && userType === "2" && !is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "achpercentageUserGeneral",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "achfixedrateUserGeneral",
                commission_rate ? commission_rate : 0
              );
            }
            setACHTypeUserGeneral(
              is_percentage ? "percentageUserGeneral" : "rateUserGeneral"
            );
          }

          // ACH User - SC
          if (transactionModeId === 2 && userType === "2" && is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "achpercentageUserSC",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "achfixedrateUserSC",
                commission_rate ? commission_rate : 0
              );
            }
            setACHTypeUserSC(is_percentage ? "percentageUserSC" : "rateUserSC");
          }

          // ACH Business - General
          if (transactionModeId === 2 && userType === "3" && !is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "achpercentageBusinessGeneral",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "achfixedrateBusinessGeneral",
                commission_rate ? commission_rate : 0
              );
            }
            setACHTypeBusinessGeneral(
              is_percentage
                ? "percentageBusinessGeneral"
                : "rateBusinessGeneral"
            );
          }

          // ACH Business - SC
          if (transactionModeId === 2 && userType === "3" && is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "achpercentageBusinessSC",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "achfixedrateBusinessSC",
                commission_rate ? commission_rate : 0
              );
            }
            setACHTypeBusinessSC(
              is_percentage ? "percentageBusinessSC" : "rateBusinessSC"
            );
          }

          // Credit Card User - General
          if (transactionModeId === 3 && userType === "2" && !is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "creditcardpercentageUserGeneral",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "creditcardfixedrateUserGeneral",
                commission_rate ? commission_rate : 0
              );
            }
            setCreditCardTypeUserGeneral(
              is_percentage ? "percentageUserGeneral" : "rateUserGeneral"
            );
          }

          // Credit Card Business - General
          if (transactionModeId === 3 && userType === "3" && !is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "creditcardpercentageBusinessGeneral",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "creditcardfixedrateBusinessGeneral",
                commission_rate ? commission_rate : 0
              );
            }

            setCreditCardTypeBusinessGeneral(
              is_percentage
                ? "percentageBusinessGeneral"
                : "rateBusinessGeneral"
            );
          }

          // Debit Card User - General
          if (transactionModeId === 6 && userType === "2" && !is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "debitcardpercentageUserGeneral",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "debitcardfixedrateUserGeneral",
                commission_rate ? commission_rate : 0
              );
            }
            setDebitCardTypeUserGeneral(
              is_percentage ? "percentageUserGeneral" : "rateUserGeneral"
            );
          }

          // Debit Card Business - General
          if (transactionModeId === 6 && userType === "3" && !is_sc) {
            if (is_percentage) {
              formik.setFieldValue(
                "debitcardpercentageBusinessGeneral",
                commission_percentage ? commission_percentage : 0
              );
            } else {
              formik.setFieldValue(
                "debitcardfixedrateBusinessGeneral",
                commission_rate ? commission_rate : 0
              );
            }
            setDebitCardTypeBusinessGeneral(
              is_percentage
                ? "percentageBusinessGeneral"
                : "rateBusinessGeneral"
            );
          }

          return commissionData;
        });
      }
    }
    getCommissionList();
  }, [updateCommissionList]);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };
  const handleErrorModalShow = () => {
    setIsErrorModalOpen(true);
  };

  const handleErrorModalHide = () => {
    setIsErrorModalOpen(false);
  };

  const handleSuccessModalShow = () => {
    setSuccessModalShow(true);
  };

  const handleSuccessModalHide = () => {
    setSuccessModalShow(false);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CommissionSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      const {
        // General Payment
        achfixedrateUserGeneral,
        achpercentageUserGeneral,
        echeckfixedrateUserGeneral,
        echeckpercentageUserGeneral,
        creditcardfixedrateUserGeneral,
        creditcardpercentageUserGeneral,
        debitcardfixedrateUserGeneral,
        debitcardpercentageUserGeneral,

        // Bussion Payment
        achfixedrateBusinessGeneral,
        achpercentageBusinessGeneral,
        echeckfixedrateBusinessGeneral,
        echeckpercentageBusinessGeneral,
        creditcardfixedrateBusinessGeneral,
        creditcardpercentageBusinessGeneral,
        debitcardfixedrateBusinessGeneral,
        debitcardpercentageBusinessGeneral,

        // SC Payment
        achfixedrateUserSC,
        echeckfixedUserSC,
        echeckpercentageUserSC,
        achpercentageUserSC,

        // SC Bussiness User
        achfixedrateBusinessSC,
        echeckfixedBusinessSC,
        echeckpercentageBusinessSC,
        achpercentageBusinessSC,
      } = values || {};
      const updatedList = [];
      commissionList.map((commission) => {
        const { transactionModeId, userType, is_sc } = commission || {};

        // E-check user - General
        if (transactionModeId === 1 && userType === "2" && !is_sc) {
          commission.commission_percentage = echeckpercentageUserGeneral;
          commission.commission_rate = echeckfixedrateUserGeneral;
          // console.log("echeckTypeUserGeneral", echeckTypeUserGeneral);
          if (echeckTypeUserGeneral === "percentageUserGeneral") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // E-check Business - General
        if (transactionModeId === 1 && userType === "3" && !is_sc) {
          commission.commission_percentage = echeckpercentageBusinessGeneral;
          commission.commission_rate = echeckfixedrateBusinessGeneral;
          // console.log("echeckTypeBusinessGeneral", echeckTypeBusinessGeneral);
          if (echeckTypeBusinessGeneral === "percentageBusinessGeneral") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // ACH User - General
        if (transactionModeId === 2 && userType === "2" && !is_sc) {
          commission.commission_percentage = achpercentageUserGeneral;
          commission.commission_rate = achfixedrateUserGeneral;
          // console.log("ACHTypeUserGeneral", ACHTypeUserGeneral);
          if (ACHTypeUserGeneral === "percentageUserGeneral") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // ACH Business - General
        if (transactionModeId === 2 && userType === "3" && !is_sc) {
          commission.commission_percentage = achpercentageBusinessGeneral;
          commission.commission_rate = achfixedrateBusinessGeneral;
          // console.log("ACHTypeBusinessGeneral", ACHTypeBusinessGeneral);
          if (ACHTypeBusinessGeneral === "percentageBusinessGeneral") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // Credit Card User - General
        if (transactionModeId === 3 && userType === "2" && !is_sc) {
          commission.commission_percentage = creditcardpercentageUserGeneral;
          commission.commission_rate = creditcardfixedrateUserGeneral;
          // console.log("creditCardTypeUserGeneral", creditCardTypeUserGeneral);
          if (creditCardTypeUserGeneral === "percentageUserGeneral") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // Credit Card Business - General
        if (transactionModeId === 3 && userType === "3" && !is_sc) {
          commission.commission_percentage = creditcardpercentageBusinessGeneral;
          commission.commission_rate = creditcardfixedrateBusinessGeneral;
          // console.log(
          //   "creditCardTypeBusinessGeneral",
          //   creditCardTypeBusinessGeneral
          // );
          if (creditCardTypeBusinessGeneral === "percentageBusinessGeneral") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // Debit Card User - General
        if (transactionModeId === 6 && userType === "2" && !is_sc) {
          commission.commission_percentage = debitcardpercentageUserGeneral;
          commission.commission_rate = debitcardfixedrateUserGeneral;
          // console.log("debitCardTypeUserGeneral", debitCardTypeUserGeneral);
          if (debitCardTypeUserGeneral === "percentageUserGeneral") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // Debit Card Business - General
        if (transactionModeId === 6 && userType === "3" && !is_sc) {
          commission.commission_percentage = debitcardpercentageBusinessGeneral;
          commission.commission_rate = debitcardfixedrateBusinessGeneral;
          // console.log(
          //   "debitCardTypeBusinessGeneral",
          //   debitCardTypeBusinessGeneral
          // );
          if (debitCardTypeBusinessGeneral === "percentageBusinessGeneral") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // ACH User - SC
        if (transactionModeId === 2 && userType === "2" && is_sc) {
          commission.commission_percentage = achpercentageUserSC;
          commission.commission_rate = achfixedrateUserSC;
          // console.log("ACHTypeUserSC", ACHTypeUserSC);
          if (ACHTypeUserSC === "percentageUserSC") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }
        // Echeck User - SC
        if (transactionModeId === 1 && userType === "2" && is_sc) {
          commission.commission_percentage = echeckpercentageUserSC;
          commission.commission_rate = echeckfixedUserSC;
          // console.log("EcheckTypeUserSC", EcheckTypeUserSC);
          if (EcheckTypeUserSC === "percentageUserSC") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // ACH Business - SC
        if (transactionModeId === 2 && userType === "3" && is_sc) {
          commission.commission_percentage = achpercentageBusinessSC;
          commission.commission_rate = achfixedrateBusinessSC;
          // console.log("ACHTypeBusinessSC", ACHTypeBusinessSC);
          if (ACHTypeBusinessSC === "percentageBusinessSC") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        // Echeck Business - SC
        if (transactionModeId === 1 && userType === "3" && is_sc) {
          commission.commission_percentage = echeckpercentageBusinessSC;
          commission.commission_rate = echeckfixedBusinessSC;
          // console.log("EcheckTypeBusinessSC", EcheckTypeBusinessSC);
          if (EcheckTypeBusinessSC === "percentageBusinessSC") {
            commission.is_percentage = true;
          } else {
            commission.is_percentage = false;
          }
        }

        updatedList.push(commission);
        return commission;
      });
      let commissionObj = {
        data: updatedList,
      };
      enableLoading();
      const commissionResponse = await editCommissionApi(commissionObj);
      disableLoading();
      const { Error } = commissionResponse || {};
      if (Error) {
        const { message } = Error || {};
        setErrorMessage(message);
        handleErrorModalShow();
        return;
      }
      handleSuccessModalShow();
      setCommissionList([]);
      setUpdateCommissionList(Math.random());
    },
  });

  return (
    <>
      <form
        // onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        <Card className="card-custom card-stretch make-payment-wrapper">
          <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
            <h3 className="card-title align-items-start flex-column">
              <span className="font-weight-bold text-dark">Commissions</span>
            </h3>
            <Button
              variant="btn btn-light-primary btn-lg"
              disabled={loading}
              onClick={() => {
                formik.handleSubmit();
              }}
            >
              Save
              {loading && (
                <span className="ml-3 mr-3 spinner spinner-white"></span>
              )}
            </Button>
          </Card.Header>
          <Card.Body>
            <Card className="card-custom card-stretch make-payment-wrapper">
              <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
                <h3 className="card-title align-items-start flex-column">
                  <span className="font-weight-bold text-dark">
                    <div className="symbol symbol-30 symbol-success mr-2">
                      <span className="symbol-label">#</span>
                    </div>
                    General Payment Commission
                  </span>
                </h3>
              </Card.Header>
              <Card.Body>
                <Card className="card-custom card-stretch make-payment-wrapper">
                  <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="font-weight-bold text-dark">
                        <div className="symbol symbol-30 symbol-success mr-2">
                          <span className="symbol-label">1</span>
                        </div>
                        For Individual User
                      </span>
                    </h3>
                  </Card.Header>
                  <Card.Body>
                    <div
                      className="login-form login-signin"
                      id="kt_login_signin_form"
                    >
                      <div>
                        <div id="ach">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              ACH
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="achradioUserGeneral"
                                    checked={
                                      ACHTypeUserGeneral ===
                                      "percentageUserGeneral"
                                    }
                                    onChange={() => {
                                      setACHTypeUserGeneral(
                                        "percentageUserGeneral"
                                      );
                                      formik.setFieldValue(
                                        "achfixedrateUserGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="achradioUserGeneral"
                                    checked={
                                      ACHTypeUserGeneral === "rateUserGeneral"
                                    }
                                    onChange={() => {
                                      setACHTypeUserGeneral("rateUserGeneral");
                                      formik.setFieldValue(
                                        "achpercentageUserGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="ACH Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="achpercentageUserGeneral"
                                  disabled={
                                    ACHTypeUserGeneral !==
                                    "percentageUserGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "achpercentageUserGeneral"
                                  )}
                                />
                                {formik.touched.achpercentageUserGeneral &&
                                formik.errors.achpercentageUserGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.achpercentageUserGeneral}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="ACH Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="achfixedrateUserGeneral"
                                  disabled={
                                    ACHTypeUserGeneral !== "rateUserGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "achfixedrateUserGeneral"
                                  )}
                                />
                                {formik.touched.achfixedrateUserGeneral &&
                                formik.errors.achfixedrateUserGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.achfixedrateUserGeneral}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="dropdown-divider"></div>
                        <div id="credit-card">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              Credit Card
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="creditcardradioUserGeneral"
                                    checked={
                                      creditCardTypeUserGeneral ===
                                      "percentageUserGeneral"
                                    }
                                    onChange={() => {
                                      setCreditCardTypeUserGeneral(
                                        "percentageUserGeneral"
                                      );
                                      formik.setFieldValue(
                                        "creditcardfixedrateUserGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="creditcardradioUserGeneral"
                                    checked={
                                      creditCardTypeUserGeneral ===
                                      "rateUserGeneral"
                                    }
                                    onChange={() => {
                                      setCreditCardTypeUserGeneral(
                                        "rateUserGeneral"
                                      );
                                      formik.setFieldValue(
                                        "creditcardpercentageUserGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="Credit Card Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="creditcardpercentageUserGeneral"
                                  disabled={
                                    creditCardTypeUserGeneral !==
                                    "percentageUserGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "creditcardpercentageUserGeneral"
                                  )}
                                />
                                {formik.touched
                                  .creditcardpercentageUserGeneral &&
                                formik.errors
                                  .creditcardpercentageUserGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .creditcardpercentageUserGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="Credit Card Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="creditcardfixedrateUserGeneral"
                                  disabled={
                                    creditCardTypeUserGeneral !==
                                    "rateUserGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "creditcardfixedrateUserGeneral"
                                  )}
                                />
                                {formik.touched
                                  .creditcardfixedrateUserGeneral &&
                                formik.errors.creditcardfixedrateUserGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .creditcardfixedrateUserGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="dropdown-divider"></div>
                        <div id="debit-card">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              Debit Card
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="debitcardradioUserGeneral"
                                    checked={
                                      debitCardTypeUserGeneral ===
                                      "percentageUserGeneral"
                                    }
                                    onChange={() => {
                                      setDebitCardTypeUserGeneral(
                                        "percentageUserGeneral"
                                      );
                                      formik.setFieldValue(
                                        "debitcardfixedrateUserGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="debitcardradioUserGeneral"
                                    checked={
                                      debitCardTypeUserGeneral ===
                                      "rateUserGeneral"
                                    }
                                    onChange={() => {
                                      setDebitCardTypeUserGeneral(
                                        "rateUserGeneral"
                                      );
                                      formik.setFieldValue(
                                        "debitcardpercentageUserGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="Debit Card Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="debitcardpercentageUserGeneral"
                                  disabled={
                                    debitCardTypeUserGeneral !==
                                    "percentageUserGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "debitcardpercentageUserGeneral"
                                  )}
                                />
                                {formik.touched
                                  .debitcardpercentageUserGeneral &&
                                formik.errors.debitcardpercentageUserGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .debitcardpercentageUserGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="Debit Card Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="debitcardfixedrateUserGeneral"
                                  disabled={
                                    debitCardTypeUserGeneral !==
                                    "rateUserGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "debitcardfixedrateUserGeneral"
                                  )}
                                />
                                {formik.touched.debitcardfixedrateUserGeneral &&
                                formik.errors.debitcardfixedrateUserGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .debitcardfixedrateUserGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="dropdown-divider"></div>
                        <div id="E-check">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              E-check
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="eacheckradioUserGeneral"
                                    checked={
                                      echeckTypeUserGeneral ===
                                      "percentageUserGeneral"
                                    }
                                    onChange={() => {
                                      setEcheckTypeUserGeneral(
                                        "percentageUserGeneral"
                                      );
                                      formik.setFieldValue(
                                        "echeckfixedrateUserGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="echeckradioUserGeneral"
                                    checked={
                                      echeckTypeUserGeneral ===
                                      "rateUserGeneral"
                                    }
                                    onChange={() => {
                                      setEcheckTypeUserGeneral(
                                        "rateUserGeneral"
                                      );
                                      formik.setFieldValue(
                                        "echeckpercentageUserGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="E-check Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="echeckpercentageUserGeneral"
                                  disabled={
                                    echeckTypeUserGeneral !==
                                    "percentageUserGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "echeckpercentageUserGeneral"
                                  )}
                                />
                                {formik.touched.echeckpercentageUserGeneral &&
                                formik.errors.echeckpercentageUserGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .echeckpercentageUserGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="E-check Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="echeckfixedrateUserGeneral"
                                  disabled={
                                    echeckTypeUserGeneral !== "rateUserGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "echeckfixedrateUserGeneral"
                                  )}
                                />
                                {formik.touched.echeckfixedrateUserGeneral &&
                                formik.errors.echeckfixedrateUserGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.echeckfixedrateUserGeneral}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*end::Form*/}
                    </div>
                  </Card.Body>
                </Card>
                <Card className="card-custom card-stretch make-payment-wrapper mt-5">
                  <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="font-weight-bold text-dark">
                        <div className="symbol symbol-30 symbol-success mr-2">
                          <span className="symbol-label">2</span>
                        </div>
                        For Bussiness User
                      </span>
                    </h3>
                  </Card.Header>
                  <Card.Body>
                    <div
                      className="login-form login-signin"
                      id="kt_login_signin_form"
                    >
                      <div>
                        <div id="ach">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              ACH
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="achradioBusinessGeneral"
                                    checked={
                                      ACHTypeBusinessGeneral ===
                                      "percentageBusinessGeneral"
                                    }
                                    onChange={() => {
                                      setACHTypeBusinessGeneral(
                                        "percentageBusinessGeneral"
                                      );
                                      formik.setFieldValue(
                                        "achfixedrateBusinessGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="achradioBusinessGeneral"
                                    checked={
                                      ACHTypeBusinessGeneral ===
                                      "rateBusinessGeneral"
                                    }
                                    onChange={() => {
                                      setACHTypeBusinessGeneral(
                                        "rateBusinessGeneral"
                                      );
                                      formik.setFieldValue(
                                        "achpercentageBusinessGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="ACH Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="achpercentageBusinessGeneral"
                                  disabled={
                                    ACHTypeBusinessGeneral !==
                                    "percentageBusinessGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "achpercentageBusinessGeneral"
                                  )}
                                />
                                {formik.touched.achpercentageBusinessGeneral &&
                                formik.errors.achpercentageBusinessGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .achpercentageBusinessGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="ACH Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="achfixedrateBusinessGeneral"
                                  disabled={
                                    ACHTypeBusinessGeneral !==
                                    "rateBusinessGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "achfixedrateBusinessGeneral"
                                  )}
                                />
                                {formik.touched.achfixedrateBusinessGeneral &&
                                formik.errors.achfixedrateBusinessGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .achfixedrateBusinessGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="dropdown-divider"></div>
                        <div id="credit-card">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              Credit Card
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="creditcardradioBusinessGeneral"
                                    checked={
                                      creditCardTypeBusinessGeneral ===
                                      "percentageBusinessGeneral"
                                    }
                                    onChange={() => {
                                      setCreditCardTypeBusinessGeneral(
                                        "percentageBusinessGeneral"
                                      );
                                      formik.setFieldValue(
                                        "creditcardfixedrateBusinessGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="creditcardradioBusinessGeneral"
                                    checked={
                                      creditCardTypeBusinessGeneral ===
                                      "rateBusinessGeneral"
                                    }
                                    onChange={() => {
                                      setCreditCardTypeBusinessGeneral(
                                        "rateBusinessGeneral"
                                      );
                                      formik.setFieldValue(
                                        "creditcardpercentageBusinessGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="Credit Card Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="creditcardpercentageBusinessGeneral"
                                  disabled={
                                    creditCardTypeBusinessGeneral !==
                                    "percentageBusinessGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "creditcardpercentageBusinessGeneral"
                                  )}
                                />
                                {formik.touched
                                  .creditcardpercentageBusinessGeneral &&
                                formik.errors
                                  .creditcardpercentageBusinessGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .creditcardpercentageBusinessGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="Credit Card Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="creditcardfixedrateBusinessGeneral"
                                  disabled={
                                    creditCardTypeBusinessGeneral !==
                                    "rateBusinessGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "creditcardfixedrateBusinessGeneral"
                                  )}
                                />
                                {formik.touched
                                  .creditcardfixedrateBusinessGeneral &&
                                formik.errors
                                  .creditcardfixedrateBusinessGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .creditcardfixedrateBusinessGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="dropdown-divider"></div>
                        <div id="debit-card">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              Debit Card
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="debitcardradioBusinessGeneral"
                                    checked={
                                      debitCardTypeBusinessGeneral ===
                                      "percentageBusinessGeneral"
                                    }
                                    onChange={() => {
                                      setDebitCardTypeBusinessGeneral(
                                        "percentageBusinessGeneral"
                                      );
                                      formik.setFieldValue(
                                        "debitcardfixedrateBusinessGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="debitcardradioBusinessGeneral"
                                    checked={
                                      debitCardTypeBusinessGeneral ===
                                      "rateBusinessGeneral"
                                    }
                                    onChange={() => {
                                      setDebitCardTypeBusinessGeneral(
                                        "rateBusinessGeneral"
                                      );
                                      formik.setFieldValue(
                                        "debitcardpercentageBusinessGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="Debit Card Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="debitcardpercentageBusinessGeneral"
                                  disabled={
                                    debitCardTypeBusinessGeneral !==
                                    "percentageBusinessGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "debitcardpercentageBusinessGeneral"
                                  )}
                                />
                                {formik.touched
                                  .debitcardpercentageBusinessGeneral &&
                                formik.errors
                                  .debitcardpercentageBusinessGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .debitcardpercentageBusinessGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="Debit Card Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="debitcardfixedrateBusinessGeneral"
                                  disabled={
                                    debitCardTypeBusinessGeneral !==
                                    "rateBusinessGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "debitcardfixedrateBusinessGeneral"
                                  )}
                                />
                                {formik.touched
                                  .debitcardfixedrateBusinessGeneral &&
                                formik.errors
                                  .debitcardfixedrateBusinessGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .debitcardfixedrateBusinessGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="dropdown-divider"></div>
                        <div id="E-check">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              E-check
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="echeckradioBusinessGeneral"
                                    checked={
                                      echeckTypeBusinessGeneral ===
                                      "percentageBusinessGeneral"
                                    }
                                    onChange={() => {
                                      setEcheckTypeBusinessGeneral(
                                        "percentageBusinessGeneral"
                                      );
                                      formik.setFieldValue(
                                        "echeckfixedrateBusinessGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="echeckradioBusinessGeneral"
                                    checked={
                                      echeckTypeBusinessGeneral ===
                                      "rateBusinessGeneral"
                                    }
                                    onChange={() => {
                                      setEcheckTypeBusinessGeneral(
                                        "rateBusinessGeneral"
                                      );
                                      formik.setFieldValue(
                                        "echeckpercentageBusinessGeneral",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="E-check Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="echeckpercentageBusinessGeneral"
                                  disabled={
                                    echeckTypeBusinessGeneral !==
                                    "percentageBusinessGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "echeckpercentageBusinessGeneral"
                                  )}
                                />
                                {formik.touched
                                  .echeckpercentageBusinessGeneral &&
                                formik.errors
                                  .echeckpercentageBusinessGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .echeckpercentageBusinessGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="E-check Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="echeckfixedrateBusinessGeneral"
                                  disabled={
                                    echeckTypeBusinessGeneral !==
                                    "rateBusinessGeneral"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "echeckfixedrateBusinessGeneral"
                                  )}
                                />
                                {formik.touched
                                  .echeckfixedrateBusinessGeneral &&
                                formik.errors.echeckfixedrateBusinessGeneral ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {
                                        formik.errors
                                          .echeckfixedrateBusinessGeneral
                                      }
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*end::Form*/}
                    </div>
                  </Card.Body>
                </Card>
              </Card.Body>
            </Card>

            <Card className="card-custom card-stretch make-payment-wrapper">
              <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
                <h3 className="card-title align-items-start flex-column">
                  <span className="font-weight-bold text-dark">
                    <div className="symbol symbol-30 symbol-success mr-2">
                      <span className="symbol-label">#</span>
                    </div>
                    Schedule Closing Payment Commission
                  </span>
                </h3>
              </Card.Header>
              <Card.Body>
                <Card className="card-custom card-stretch make-payment-wrapper">
                  <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="font-weight-bold text-dark">
                        <div className="symbol symbol-30 symbol-success mr-2">
                          <span className="symbol-label">1</span>
                        </div>
                        For Individual User
                      </span>
                    </h3>
                  </Card.Header>
                  <Card.Body>
                    <div
                      className="login-form login-signin"
                      id="kt_login_signin_form"
                    >
                      <div>
                        <div id="ach">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              ACH
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="achradioUserSC"
                                    checked={
                                      ACHTypeUserSC === "percentageUserSC"
                                    }
                                    onChange={() => {
                                      setACHTypeUserSC("percentageUserSC");
                                      formik.setFieldValue(
                                        "achfixedrateUserSC",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="achradioUserSC"
                                    checked={ACHTypeUserSC === "rateUserSC"}
                                    onChange={() => {
                                      setACHTypeUserSC("rateUserSC");
                                      formik.setFieldValue(
                                        "achpercentageUserSC",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="ACH Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="achpercentageUserSC"
                                  disabled={
                                    ACHTypeUserSC !== "percentageUserSC"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "achpercentageUserSC"
                                  )}
                                />
                                {formik.touched.achpercentageUserSC &&
                                formik.errors.achpercentageUserSC ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.achpercentageUserSC}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="ACH Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="achfixedrateUserSC"
                                  disabled={ACHTypeUserSC !== "rateUserSC"}
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "achfixedrateUserSC"
                                  )}
                                />
                                {formik.touched.achfixedrateUserSC &&
                                formik.errors.achfixedrateUserSC ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.achfixedrateUserSC}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="dropdown-divider"></div>
                        <div id="E-check">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              E-check
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="echeckradioUserSC"
                                    checked={
                                      EcheckTypeUserSC === "percentageUserSC"
                                    }
                                    onChange={() => {
                                      setEcheckTypeUserSC("percentageUserSC");
                                      formik.setFieldValue(
                                        "echeckfixedUserSC",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="echeckradioUserSC"
                                    checked={EcheckTypeUserSC === "rateUserSC"}
                                    onChange={() => {
                                      setEcheckTypeUserSC("rateUserSC");
                                      formik.setFieldValue(
                                        "echeckpercentageUserSC",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="E-check Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="echeckpercentageUserSC"
                                  disabled={
                                    EcheckTypeUserSC !== "percentageUserSC"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "echeckpercentageUserSC"
                                  )}
                                />
                                {formik.touched.echeckpercentageUserSC &&
                                formik.errors.echeckpercentageUserSC ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.echeckpercentageUserSC}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="E-check Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="echeckfixedUserSC"
                                  disabled={EcheckTypeUserSC !== "rateUserSC"}
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps("echeckfixedUserSC")}
                                />
                                {formik.touched.echeckfixedUserSC &&
                                formik.errors.echeckfixedUserSC ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.echeckfixedUserSC}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
                <Card className="card-custom card-stretch make-payment-wrapper mt-5">
                  <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="font-weight-bold text-dark">
                        <div className="symbol symbol-30 symbol-success mr-2">
                          <span className="symbol-label">2</span>
                        </div>
                        For Bussiness User
                      </span>
                    </h3>
                  </Card.Header>
                  <Card.Body>
                    <div
                      className="login-form login-signin"
                      id="kt_login_signin_form"
                    >
                      <div>
                        <div id="ach">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              ACH
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="achradioBusinessSC"
                                    checked={
                                      ACHTypeBusinessSC ===
                                      "percentageBusinessSC"
                                    }
                                    onChange={() => {
                                      setACHTypeBusinessSC(
                                        "percentageBusinessSC"
                                      );
                                      formik.setFieldValue(
                                        "achfixedrateBusinessSC",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="achradioBusinessSC"
                                    checked={
                                      ACHTypeBusinessSC === "rateBusinessSC"
                                    }
                                    onChange={() => {
                                      setACHTypeBusinessSC("rateBusinessSC");
                                      formik.setFieldValue(
                                        "achpercentageBusinessSC",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="ACH Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="achpercentageBusinessSC"
                                  disabled={
                                    ACHTypeBusinessSC !== "percentageBusinessSC"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "achpercentageBusinessSC"
                                  )}
                                />
                                {formik.touched.achpercentageUserSC &&
                                formik.errors.achpercentageUserSC ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.achpercentageUserSC}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="ACH Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="achfixedrateBusinessSC"
                                  disabled={
                                    ACHTypeBusinessSC !== "rateBusinessSC"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "achfixedrateBusinessSC"
                                  )}
                                />
                                {formik.touched.achfixedrateBusinessSC &&
                                formik.errors.achfixedrateBusinessSC ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.achfixedrateBusinessSC}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="dropdown-divider"></div>
                        <div id="E-check">
                          <div className="text-left mb-10">
                            <h4 className="h4 font-size-md-h4 font-weight-bolder">
                              E-check
                            </h4>
                          </div>

                          <div className="form-group fv-plugins-icon-container">
                            <div className="row">
                              <div className="col radio-list-commission">
                                <label className="radio radio-success mb-5">
                                  <input
                                    type="radio"
                                    name="echeckradioBusinessSC"
                                    checked={
                                      EcheckTypeBusinessSC ===
                                      "percentageBusinessSC"
                                    }
                                    onChange={() => {
                                      setEcheckTypeBusinessSC(
                                        "percentageBusinessSC"
                                      );
                                      formik.setFieldValue(
                                        "echeckfixedBusinessSC",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Percentage
                                </label>
                              </div>
                              <div className="col radio-list-commission">
                                <label className="radio radio-success">
                                  <input
                                    type="radio"
                                    name="echeckradioBusinessSC"
                                    checked={
                                      EcheckTypeBusinessSC === "rateBusinessSC"
                                    }
                                    onChange={() => {
                                      setEcheckTypeBusinessSC("rateBusinessSC");
                                      formik.setFieldValue(
                                        "echeckpercentageBusinessSC",
                                        0
                                      );
                                    }}
                                  />
                                  <span className="mr-1"></span>
                                  Fixed Rate
                                </label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-6">
                                <input
                                  placeholder="E-check Commission Percentage i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="echeckpercentageBusinessSC"
                                  disabled={
                                    EcheckTypeBusinessSC !==
                                    "percentageBusinessSC"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "echeckpercentageBusinessSC"
                                  )}
                                />
                                {formik.touched.echeckpercentageBusinessSC &&
                                formik.errors.echeckpercentageBusinessSC ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.echeckpercentageBusinessSC}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                              <div className="col-6">
                                <input
                                  placeholder="E-check Commission Fixed Rate i.e. 02.50"
                                  type="number"
                                  className={`form-control h-auto py-4 py-md-5 px-6`}
                                  name="echeckfixedBusinessSC"
                                  disabled={
                                    EcheckTypeBusinessSC !== "rateBusinessSC"
                                  }
                                  onWheel={(e) => e.target.blur()}
                                  {...formik.getFieldProps(
                                    "echeckfixedBusinessSC"
                                  )}
                                />
                                {formik.touched.echeckfixedBusinessSC &&
                                formik.errors.echeckfixedBusinessSC ? (
                                  <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                      {formik.errors.echeckfixedBusinessSC}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Card.Body>
            </Card>
          </Card.Body>
        </Card>
      </form>
      <SuccessModal
        message={"You have successfully updated commission details!"}
        isConfirmModal={isSuccessModalShow}
        handleConfirmHide={handleSuccessModalHide}
        successIcon={
          <div className="success-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
              />
            </span>
          </div>
        }
      />
      <ErrorModal
        message={errorMessage}
        isErrorModalOpen={isErrorModalOpen}
        hideErrorModal={handleErrorModalHide}
        errorIcon={
          <div className="danger-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
              />
            </span>
          </div>
        }
        errorButtonLabel={"Close"}
        errorOnClick={handleErrorModalHide}
      />
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(Commission));
